export const DESTINATION = {
  RESET: '/queue/machines/:machineId/commands',
  PAGE_USAGE: '/app/metrics/usage',
};

export const RECONNECT_DELAY = 1000 * 10 * 2; // 20초
export const PAGE_USAGE_DELAY = 1000 * 10; // 10초
